import React, { createContext, useState } from "react";

export const RedirectUrlValue = createContext();

const RedirectUrlValueProvider = (props) => {
    const [brand, setBrand] = useState(localStorage.getItem("brand"));

    const toggleredirectUrl = (brand) => {
        localStorage.setItem("brand", brand);
        setBrand(brand);
    };

    return (
        <RedirectUrlValue.Provider value={{ toggleredirectUrl, brand }}>
            {props.children}
        </RedirectUrlValue.Provider>
    );
};

export default RedirectUrlValueProvider;
